import { useEffect } from 'react';
import { getEndOfDayStatus } from '../business-logic/end-of-day-status';
import { emeraldModalCounts } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { isEmeraldSellingService } from 'src/xlr-configuration/pos-service-type-utils';

export const useEndOfDayStatus = (transactionIdExists?: boolean): void => {
  useEffect(() => {
    const isEmerald = isEmeraldSellingService();
    if (!transactionIdExists && !window.Cypress && !isEmerald) {
      //TODO: this should be moved to the POS config .Also find out a way to shorten the time for cypress test
      const defaultEndOfDayStatusInterval: number = 120000;
      endOfDayStatus();
      const interval = setInterval(endOfDayStatus, defaultEndOfDayStatusInterval);
      return () => clearInterval(interval);
    }
  }, [transactionIdExists]);
};

const endOfDayStatus = async () => {
  const modalCount = emeraldModalCounts();
  if (!modalCount) {
    await getEndOfDayStatus();
  }
};
